export function setAccessToken(accessTokens) {
	return localStorage.setItem('accessToken', accessTokens);
}
